<template>
  <PublicView>
    <div id="product-page" class="pt-3" v-if="product">
      <div class="breadcrumb-container">
        <div class="container-fluid">
          <div class="row">
            <div class="col-12">
              <ul class="breadcrumb">
                <li class="breadcrumb-item">
                  <router-link to="/"><i class="fas fa-home"></i></router-link>
                </li>
                <li v-for="b in product.breadcrumb" :key="b._id" class="breadcrumb-item">
                  <router-link :to="cateLink(b)">
                    {{ b.name }}
                  </router-link>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div class="container-fluid">
        <div class="row">
          <div class="col-12 col-sm-6 col-lg-4 mb-4">
            <div id="product-preview">
              <span class="sale-label" v-if="product.priceMode != 2 && product.oldPrice != 0"
                v-bind:class="{ 'big-sale': discount(product) >= 30 }">{{
                discount(product) }}%</span>
              <span class="sale-label big-sale" v-if="product.priceMode == 2">Call</span>
              <div id="product-preview-2">
                <div id="product-preview-3">
                  <img :src="resizeImage(bigImage, 350, 350)" alt="">
                </div>
              </div>
            </div>

            <div class="animation-cart" :style="animationStyle"
              v-bind:class="{ 'show': showAnimation, 'move': moveAnimation }">
              <div class="cen">
                <img :src="bigImage" />
              </div>
            </div>
            <div id="product-image-list">
              <swiper :slidesPerView="'auto'" :spaceBetween="10" :pagination="{
                clickable: true,
              }" :modules="modules" class="mySwiper">
                <swiper-slide v-for="i in product.images3" :key="i" v-on:click="bigImage = i">
                  <img :src="resizeImage(i, 80, 80)" alt="">
                </swiper-slide>
              </swiper>
            </div>
          </div>
          <div class="col-12 col-sm-6 col-xl-5">
            <div id="product-content">
              <div id="product-title">
                <h1>{{ product.name }}</h1>
              </div>

              <div id="product-code" @click="copyProductCode" v-bind:class="{ 'copy-success': copySuccess }">
                <span style="cursor: pointer;" title="Nhấp để sao chép mã sản phẩm">
                  Mã sản phẩm: {{ productCode(product.code) }}
                </span>
              </div>
              <div id="product-price">
                <h2>
                  <p style="border: 1px solid #dfe0e1; padding: 10px; border-radius: 5px;" v-if="product.priceMode == 2"
                    v-html="product.priceMess"></p>
                  <span class="price" v-if="product.priceMode != 2">{{ price(showPrice(product)) }}</span>
                  <span class="old-price">Giá gốc: {{
                    price(product.oldPrice) }}</span>
                </h2>
                <h3 v-if="product.priceMode != 2">
                  Tiết kiệm: {{ price(Number(product.oldPrice) - Number(showPrice(product))) }}
                </h3>
              </div>
              <div id="product-options" v-if="product.productOptions && product.productOptions.length > 0">
                <h2>Chọn phiên bản</h2>
                <div id="product-options-list">
                  <div class="product-option-item" v-bind:class="{ 'active': option._id == product._id }"
                    v-for="option in product.productOptions" :key="option._id">
                    <router-link :to="productLink(option)">{{ option.subline }}</router-link>
                  </div>
                </div>
              </div>
              <div v-if="product.promote" id="product-promote">
                <div v-html="product.promote"></div>
              </div>
              <div id="action-wrap">
                <div id="call-product">
                  <a href="tel:0915761838"><i class="fas fa-phone"></i></a>
                  <a href="tel:0915761838">
                    <span class="t1">0</span>
                    <span class="t2">9</span>
                    <span class="t3">1</span>
                    <span class="t4">5</span>
                    <span class="t5">&nbsp;7</span>
                    <span class="t6">6</span>
                    <span class="t7">1</span>
                    <span class="t8">&nbsp;8</span>
                    <span class="t9">3</span>
                    <span class="t10">8</span>
                  </a>
                </div>

                <button id="add-to-cart" v-on:click="addToCart">
                  <i class="fas fa-cart-plus"></i> Thêm vào giỏ hàng
                </button>
              </div>
            </div>
          </div>
          <div class="col-12 col-xl-3 ">

            <div id="product-support">
              <h2>Tài liệu hỗ trợ</h2>
              <div id="product-support-content">
                <div>
                  <a class="btn" v-if="product.cad" :href="product.cad" target="__blank">Xem mô hình 3D/bản vẽ CAD</a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row">

          <div class="col-12 col-xl-9">
            <div id="product-description">
              <h2>Mô tả sản phẩm</h2>
              <div id="product-description-content" v-html="product.description"></div>
            </div>
          </div>
          <div class="col-12 col-xl-3">

            <div id="product-specs" v-if="product.specs">
              <h2>Thông số kỹ thuật</h2>
              <div id="product-specs-table">
                <table class="table">
                  <tbody>
                    <tr v-for="s in product.specs" :key="s">
                      <td>{{ s.title }}</td>
                      <td>{{ s.body }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
        <div></div>
        <div></div>
      </div>
    </div>
  </PublicView>
</template>
<script>
// Import Swiper Vue.js components
import { Swiper, SwiperSlide } from 'swiper/vue';

// Import Swiper styles
import 'swiper/css';

import 'swiper/css/pagination';


const axios = require("axios").default;
import PublicView from "@/components/PublicView.vue";
export default {
  name: "DanhMucView",
  data() {
    return {
      viewCad: false,
      products: [],
      totalItems: 0,
      currentPage: 1,
      bigImage: "",
      copySuccess: false,
      moveAnimation: false,
      showAnimation: false
    };
  },
  mounted() {
    if (this.product) {
      this.bigImage = this.product.images3 && this.product.images3.length > 0 ? this.product.images3[0] : "";
      if (this.product) {
        this.setMetadata(this.product);
      }
    }
    window.scrollTo(0, 0);

  },
  computed: {
    totalPages() {
      return Math.ceil(this.totalItems / 28);
    },
    product() {
      return this.$store.getters.product(this.$route.params.id);
    }
  },
  watch: {
    product(val) {
      this.bigImage = val.images3 && val.images3.length > 0 ? val.images3[0] : "";

      if (val) {
        this.setMetadata(val);
      }
    },
    copySuccess(val) {
      if (val) {
        setTimeout(() => {
          this.copySuccess = false;
        }, 3000);
      }
    }
  },
  methods: {
    resizeImage(link, width, height) {
      const test = /^\/images\/(.+)\.(jpg|png|webp)$/.exec(link);
      if (test) {
        // Đổi link ban đầu thành link đã được resize (ví dụ sử dụng một service resize)
        return "/images-thumb/" + test[1] + "." + test[2] + "." + width + "." + height + "." + test[2];
      } else {
        return link;
      }
    },
    addToCart() {

      let dom = this.$el.querySelector('#add-to-cart');
      let domImage = this.$el.querySelector('#product-preview-3 img');
      let rectImage = domImage.getBoundingClientRect();
      this.animationStyle = `top: ${rectImage.top}px; left: ${rectImage.left}px; width: ${rectImage.width}px; height: ${rectImage.height}px;`;
      const t = this;
      t.showAnimation = true;
      dom.classList.add("btn-react");
      setTimeout(function () {
        dom.classList.remove("btn-react");
      }, 200)
      setTimeout(function () {
        t.moveAnimation = true;
      }, 500)

      setTimeout(function () {

        t.showAnimation = false;
        t.moveAnimation = false;
        t.$store.commit("addToCart", t.productCode(t.product.code));
      }, 1700)
    },
    setMetadata(product) {
      if (product.seo_data) {
        if (product.seo_data.title) {
          let titleTag = document.querySelector("title");
          if (!titleTag) {
            titleTag = document.createElement("title");
            document.head.appendChild(titleTag);
            titleTag = document.querySelector("title");
          }
          titleTag.innerText = product.seo_data.title + " - hafelevietnam.co";
          let metaTag = document.querySelector("meta[name='title']");
          if (!metaTag) {
            metaTag = document.createElement("meta");
            metaTag.setAttribute("name", "title");
            document.head.appendChild(metaTag);
            metaTag = document.querySelector("meta[name='title']");
          }
          metaTag.content = product.seo_data.title + " - hafelevietnam.co";
          let metaTagOg = document.querySelector("meta[property='og:title']");
          if (!metaTagOg) {
            metaTagOg = document.createElement("meta");
            metaTagOg.setAttribute("property", "og:title");
            document.head.appendChild(metaTagOg);
            metaTagOg = document.querySelector("meta[property='og:title']");
          }
          metaTagOg.content = product.seo_data.title + " - hafelevietnam.co";
        }
        if (product.seo_data.description) {
          let metaDescriptionTag = document.querySelector("meta[name='description']");
          if (!metaDescriptionTag) {
            metaDescriptionTag = document.createElement("meta");
            metaDescriptionTag.setAttribute("name", "description");
            document.head.appendChild(metaDescriptionTag);
            metaDescriptionTag = document.querySelector("meta[name='description']");
          }
          metaDescriptionTag.content = product.seo_data.description;
          let metaDescriptionTagOg = document.querySelector("meta[property='og:description']");
          if (!metaDescriptionTagOg) {
            metaDescriptionTagOg = document.createElement("meta");
            metaDescriptionTagOg.setAttribute("property", "og:description");
            document.head.appendChild(metaDescriptionTagOg);
            metaDescriptionTagOg = document.querySelector("meta[property='og:description']");
          }
          metaDescriptionTagOg.content = product.seo_data.description;
        }
      }
      if (product.avatar && product.avatar.length > 0) {
        let metaImageTagOg = document.querySelector("meta[property='og:image']");
        if (!metaImageTagOg) {
          metaImageTagOg = document.createElement("meta");
          metaImageTagOg.setAttribute("property", "og:image");
          document.head.appendChild(metaImageTagOg);
          metaImageTagOg = document.querySelector("meta[property='og:image']");
        }
        metaImageTagOg.content = product.avatar[0] == "/" ? "https://hafelevietnam.co" + product.avatar : product.avatar;
      }
      let metaUrlTag = document.querySelector("meta[property='og:url']");
      if (!metaUrlTag) {
        metaUrlTag = document.createElement("meta");
        metaUrlTag.setAttribute("property", "og:url");
        document.head.appendChild(metaUrlTag);
        metaUrlTag = document.querySelector("meta[property='og:url']");
      }
      metaUrlTag.content = "https://hafelevietnam.co" + this.$route.path;
      let linkCanonicalTag = document.querySelector("link[rel='canonical']");
      if (!linkCanonicalTag) {
        linkCanonicalTag = document.createElement("link");
        linkCanonicalTag.setAttribute("rel", "canonical");
        document.head.appendChild(linkCanonicalTag);
        linkCanonicalTag = document.querySelector("link[rel='canonical']");
      }
      linkCanonicalTag.href = "https://hafelevietnam.co" + this.$route.path;
    },
    copyProductCode() {
      const t = this;
      const code = t.productCode(this.product.code);
      if (navigator.clipboard && window.isSecureContext) {
        navigator.clipboard.writeText(code)
          .then(() => {
            t.copySuccess = true;
          })
      } else {
        // Fallback method using a temporary textarea element
        const textarea = document.createElement('textarea');
        textarea.value = code;
        textarea.style.position = 'fixed';
        textarea.style.left = '-999999px';
        document.body.appendChild(textarea);
        textarea.focus();
        textarea.select();
        try {
          document.execCommand('copy');
          t.copySuccess = true;
        } catch {
          console;
        }
        document.body.removeChild(textarea);
      }
    },

    discount(p) {
      if (p.priceMode == 1) {
        return p.priceLevel;
      }
      let oldPrice = Number(p.oldPrice);
      let price = Number(p.price);
      return Math.floor(((oldPrice - price) / oldPrice) * 100);
    },
    productCode(code) {
      if (code.length == 8) {
        return code.substring(0, 3) + "." + code.substring(3, 5) + "." + code.substring(5);
      } else {
        return code;
      }
    },
    goToPage(page) {
      this.currentPage = page;
      this.getAllProducts();
    },
    async getAllProducts() {
      let data = await axios.get(`/api/all-products/cate/${this.$route.params.id}/default/${this.currentPage}`);
      if (data && data.data) {
        this.products = data.data.products;
        this.totalItems = data.data.total;
      }

    },
    removeVietnameseTones(str) {
      str = str.replace(/à|á|ạ|ả|ã|â|ầ|ấ|ậ|ẩ|ẫ|ă|ằ|ắ|ặ|ẳ|ẵ/g, "a");
      str = str.replace(/è|é|ẹ|ẻ|ẽ|ê|ề|ế|ệ|ể|ễ/g, "e");
      str = str.replace(/ì|í|ị|ỉ|ĩ/g, "i");
      str = str.replace(/ò|ó|ọ|ỏ|õ|ô|ồ|ố|ộ|ổ|ỗ|ơ|ờ|ớ|ợ|ở|ỡ/g, "o");
      str = str.replace(/ù|ú|ụ|ủ|ũ|ư|ừ|ứ|ự|ử|ữ/g, "u");
      str = str.replace(/ỳ|ý|ỵ|ỷ|ỹ/g, "y");
      str = str.replace(/đ/g, "d");
      str = str.replace(/À|Á|Ạ|Ả|Ã|Â|Ầ|Ấ|Ậ|Ẩ|Ẫ|Ă|Ằ|Ắ|Ặ|Ẳ|Ẵ/g, "A");
      str = str.replace(/È|É|Ẹ|Ẻ|Ẽ|Ê|Ề|Ế|Ệ|Ể|Ễ/g, "E");
      str = str.replace(/Ì|Í|Ị|Ỉ|Ĩ/g, "I");
      str = str.replace(/Ò|Ó|Ọ|Ỏ|Õ|Ô|Ồ|Ố|Ộ|Ổ|Ỗ|Ơ|Ờ|Ớ|Ợ|Ở|Ỡ/g, "O");
      str = str.replace(/Ù|Ú|Ụ|Ủ|Ũ|Ư|Ừ|Ứ|Ự|Ử|Ữ/g, "U");
      str = str.replace(/Ỳ|Ý|Ỵ|Ỷ|Ỹ/g, "Y");
      str = str.replace(/Đ/g, "D");
      // Some system encode vietnamese combining accent as individual utf-8 characters
      // Một vài bộ encode coi các dấu mũ, dấu chữ như một kí tự riêng biệt nên thêm hai dòng này
      str = str.replace(/\u0300|\u0301|\u0303|\u0309|\u0323/g, ""); // ̀ ́ ̃ ̉ ̣  huyền, sắc, ngã, hỏi, nặng
      str = str.replace(/\u02C6|\u0306|\u031B/g, ""); // ˆ ̆ ̛  Â, Ê, Ă, Ơ, Ư
      // Remove extra spaces
      // Bỏ các khoảng trắng liền nhau
      str = str.replace(/ + /g, " ");
      str = str.trim();
      // Remove punctuations
      // Bỏ dấu câu, kí tự đặc biệt
      str = str.replace(/!|@|%|\^|\*|\(|\)|\+|=|<|>|\?|\/|,|\.|:|;|'|"|&|#|\[|\]|~|\$|_|`|-|{|}|\||\\/g, " ");
      return str;
    },
    cateLink(cateObj) {
      return "/danh-muc/" + this.removeVietnameseTones(cateObj.name).replaceAll(" ", "-").toLowerCase() + "/" + cateObj._id;
    },

    productLink(p) {
      return `/san-pham/${this.removeVietnameseTones(p.name).replaceAll(" ", "-").toLowerCase()}/${this.productCode(p.code)}`;
    },
    showPrice(p) {
      if (p.priceMode == 1) {
        return Math.round(Number(p.oldPrice) * (100 - Number(p.priceLevel)) / 100);
      } else if (p.priceMode == 2) {
        return p.priceMess;
      }
      return p.price;
    },
    price(price) {
      const config = {
        style: 'currency',
        currency: 'VND',
        maximumFractionDigits: 0
      };
      return new Intl.NumberFormat('vi-VN', config).format(price);
    },
  },
  components: {
    PublicView,

    Swiper,
    SwiperSlide,
  }
};
</script>
<style lang="less">

  @keyframes shake {
    0% {
      transform: scale(1) rotateZ(0);
    }

    5% {
      transform: scale(1.1) rotateZ(0);
      color: black;
    }

    7.5% {
      transform: scale(1.1) rotateZ(-10deg);
      color: #ad052d;
    }

    10% {
      transform: scale(1.1) rotateZ(10deg);
    }

    12.5% {
      transform: scale(1.1) rotateZ(-10deg);
    }

    15% {
      transform: scale(1.1) rotateZ(10deg);
    }

    17.5% {
      transform: scale(1.1) rotateZ(-10deg);
    }

    20% {
      transform: scale(1.1) rotateZ(10deg);
    }

    22.5% {
      transform: scale(1.1) rotateZ(-10deg);
    }

    25% {
      transform: scale(1.1) rotateZ(10deg);
    }

    27.5% {
      transform: scale(1.1) rotateZ(-10deg);
    }

    30% {
      transform: scale(1.1) rotateZ(10deg);
    }

    32.5% {
      transform: scale(1.1) rotateZ(-10deg);
    }

    35% {
      transform: scale(1) rotateZ(10deg);
      color: #ad052d;
    }

    40% {
      transform: rotateZ(0);
      color: black;
    }

    100% {
      transform: rotateZ(0);
    }
  }


  @keyframes at1 {
    0% {
      transform: scale(1);
    }

    40% {
      transform: scale(1);
      font-weight: normal;
      color: black;
    }

    44% {
      transform: scale(2);
      font-weight: bold;
      color: #ad052d;
    }

    48% {
      transform: scale(1);
      font-weight: normal;
      color: black;
    }

    100% {
      transform: rotateZ(0);
    }
  }

  @keyframes at2 {
    0% {
      transform: scale(1);
    }

    42% {
      transform: scale(1);
      font-weight: normal;
      color: black;
    }

    46% {
      transform: scale(2);
      font-weight: bold;
      color: #ad052d;
    }

    50% {
      transform: scale(1);
      font-weight: normal;
      color: black;
    }

    100% {
      transform: rotateZ(0);
    }
  }

  @keyframes at3 {
    0% {
      transform: scale(1);
    }

    44% {
      transform: scale(1);
      font-weight: normal;
      color: black;
    }

    48% {
      transform: scale(2);
      font-weight: bold;
      color: #ad052d;
    }

    52% {
      transform: scale(1);
      font-weight: normal;
      color: black;
    }

    100% {
      transform: rotateZ(0);
    }
  }

  @keyframes at4 {
    0% {
      transform: scale(1);
    }

    46% {
      transform: scale(1);
      font-weight: normal;
      color: black;
    }

    50% {
      transform: scale(2);
      font-weight: bold;
      color: #ad052d;
    }

    54% {
      transform: scale(1);
      font-weight: normal;
      color: black;
    }

    100% {
      transform: rotateZ(0);
    }
  }

  @keyframes at5 {
    0% {
      transform: scale(1);
    }

    48% {
      transform: scale(1);
      font-weight: normal;
      color: black;
    }

    52% {
      transform: scale(2);
      font-weight: bold;
      color: #ad052d;
    }

    56% {
      transform: scale(1);
      font-weight: normal;
      color: black;
    }

    100% {
      transform: rotateZ(0);
    }
  }

  @keyframes at6 {
    0% {
      transform: scale(1);
    }

    50% {
      transform: scale(1);
      font-weight: normal;
      color: black;
    }

    54% {
      transform: scale(2);
      font-weight: bold;
      color: #ad052d;
    }

    58% {
      transform: scale(1);
      font-weight: normal;
      color: black;
    }

    100% {
      transform: rotateZ(0);
    }
  }

  @keyframes at7 {
    0% {
      transform: scale(1);
    }

    52% {
      transform: scale(1);
      font-weight: normal;
      color: black;
    }

    56% {
      transform: scale(2);
      font-weight: bold;
      color: #ad052d;
    }

    60% {
      transform: scale(1);
      font-weight: normal;
      color: black;
    }

    100% {
      transform: rotateZ(0);
    }
  }

  @keyframes at8 {
    0% {
      transform: scale(1);
    }

    54% {
      transform: scale(1);
      font-weight: normal;
      color: black;
    }

    58% {
      transform: scale(2);
      font-weight: bold;
      color: #ad052d;
    }

    62% {
      transform: scale(1);
      font-weight: normal;
      color: black;
    }

    100% {
      transform: rotateZ(0);
    }
  }

  @keyframes at9 {
    0% {
      transform: scale(1);
    }

    56% {
      transform: scale(1);
      font-weight: normal;
      color: black;
    }

    60% {
      transform: scale(2);
      font-weight: bold;
      color: #ad052d;
    }

    64% {
      transform: scale(1);
      font-weight: normal;
      color: black;
    }

    100% {
      transform: rotateZ(0);
    }
  }

  @keyframes at10 {
    0% {
      transform: scale(1);
    }

    58% {
      transform: scale(1);
      font-weight: normal;
      color: black;
    }

    62% {
      transform: scale(2);
      font-weight: bold;
      color: #ad052d;
    }

    66% {
      transform: scale(1);
      font-weight: normal;
      color: black;
    }

    100% {
      transform: rotateZ(0);
    }
  }

  #product-image-list {
    .swiper {
      .swiper-slide {
        border: 1px solid #dfe0e1;
        width: 80px;
        height: 80px;
        padding: 10px;

        img {
          max-width: 100%;
          max-height: 100%;
        }
      }
    }

  }

  #product-page {
    .animation-cart {
      position: fixed;
      justify-content: center;
      flex-direction: column;
      display: none;
      z-index: 10000;
      opacity: 1;

      .cen {
        display: flex;
        justify-content: center;
        max-height: 100%;
        max-width: 100%;
      }

      img {
        max-width: 100%;
        max-height: 100%;
      }

      &.show {
        display: flex;
        transition: top 1s .5s, left 1s .5s, width 1s .5s, height 1s .5s, opacity 0.8s 0.7s, box-shadow .5s;
      }

      &.move {
        -webkit-box-shadow: 0 8px 17px 2px rgba(0, 0, 0, 0.14), 0 3px 14px 2px rgba(0, 0, 0, 0.12), 0 5px 5px -3px rgba(0, 0, 0, 0.2);
        box-shadow: 0 8px 17px 2px rgba(0, 0, 0, 0.14), 0 3px 14px 2px rgba(0, 0, 0, 0.12), 0 5px 5px -3px rgba(0, 0, 0, 0.2);
        top: 10px !important;
        left: calc(100vw - 80px) !important;
        width: 20px !important;
        height: 20px !important;
        opacity: 0;
      }
    }
  }

  #action-wrap {
    margin-top: 20px;
    display: flex;
    flex-wrap: wrap;
    gap: 10px;

    #call-product {
      border-radius: 5px;
      background-color: white;
      border: 1px solid #ad052d;
      color: white;
      padding: 8px 15px;
      display: inline-block;

      a {
        color: #ad052d;
        text-decoration: none;

        .fa-phone {
          animation: shake 4s infinite;
          margin-right: 5px;
          ;
        }

        span {
          display: inline-block;
        }

        span.t1 {
          animation: at1 4s infinite;

        }

        span.t2 {
          animation: at2 4s infinite;
        }

        span.t3 {
          animation: at3 4s infinite;
        }

        span.t4 {
          animation: at4 4s infinite;
        }

        span.t5 {
          animation: at5 4s infinite;
        }

        span.t6 {
          animation: at6 4s infinite;
        }

        span.t7 {
          animation: at7 4s infinite;
        }

        span.t8 {
          animation: at8 4s infinite;
        }

        span.t9 {
          animation: at9 4s infinite;
        }

        span.t10 {
          animation: at10 4s infinite;
        }
      }
    }

    #add-to-cart {
      border-radius: 5px;
      background-color: #ad052d;
      border: 1px solid #ad052d;
      color: white;
      padding: 8px 15px;
      display: inline-block;
      transition: transform .2s;

      &.btn-react {
        transform: scale(0.8);
      }


    }
  }

  #product-description {
    padding-top: 30px;
    text-align: left;

    #product-description-content {
      border: 1px solid #dfe0e1;
      padding: 20px;

      img {
        max-width: 100%;
      }
    }
  }

  #product-support {
    padding-top: 30px;
    text-align: left;

    #product-support-content {
      border: 1px solid #dfe0e1;
      padding: 20px;
    }

  }

  #product-preview {
    border: 1px solid #dfe0e1;
    margin-bottom: 20px;
    padding-bottom: 100%;
    position: relative;

    .sale-label {
      position: absolute;
      top: 6px;
      left: 12px;
      background-color: #ad052d;
      font-size: 15px;
      z-index: 1000;
      color: white;
      line-height: 20px;
      padding: 6px 12px;
      border-radius: 20px;
      font-weight: 600;

      &.big-sale {
        &::after {
          content: "";
          position: absolute;
          top: 0;
          left: 0;
          bottom: 0;
          right: 0;
          background-color: #ad052c7a;
          border-radius: 5px;
          z-index: -1;
          animation: scalePulse 1s infinite;
        }

        &::before {
          content: "";
          position: absolute;
          top: 0;
          left: 0;
          bottom: 0;
          right: 0;
          background-color: #ad052c7a;
          border-radius: 5px;
          z-index: -1;
          animation: 1s scalePulse .5s infinite;
        }
      }

    }

    #product-preview-2 {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      display: flex;
      justify-content: center;
      flex-direction: column;

      #product-preview-3 {
        display: flex;
        justify-content: center;

        img {
          max-width: 100%;
          max-height: 100%;
        }
      }
    }

  }

  #product-specs {
    text-align: left;
    margin-top: 30px;
    padding-top: 30px;

    h2 {
      margin-bottom: 20px;
    }

    table {
      tr {
        td {
          font-size: 14px;
        }
      }
    }

  }

  #product-options {
    padding-top: 20px;

    h2 {
      font-size: 18px;
    }

    #product-options-list {
      display: flex;
      flex-wrap: wrap;
      gap: 10px;
    }

    .product-option-item {
      padding: 8px;
      background-color: #e9e9e9;
      font-size: 14px;
      color: white;
      border-radius: 20px;

      a {
        text-decoration: none;
        color: black;
      }

      &.active {
        outline: 1px solid #ad052d;

        a {
          color: #ad052d;
        }

      }

    }
  }

  @media (min-width: 1200px) {
    #product-specs {
      margin-top: 0;
    }
  }

  #product-content {
    text-align: left;

    #product-title {
      h1 {
        font-size: 28px;
        font-weight: bold;
        margin-bottom: 12px;
      }
    }

    #product-price {
      h2 {
        font-size: 22px;
      }

      h3 {
        font-size: 18px;
        color: #ccc;
      }

      .price {
        font-weight: bold;
      }

      .old-price {
        color: #999;
        text-decoration: line-through;
        margin-left: 10px;
      }
    }

    #product-code {
      margin: 15px 0 15px 0;
      position: relative;

      >span {
        font-size: 12px;
        color: #999;
        border-radius: 15px;
        background-color: #ad052d;
        display: inline-block;
        padding: 5px 15px;
        color: white;
      }

      &::before {
        position: absolute;
        top: 0px;
        left: 0;
        content: "Sao chép thành công!";
        font-size: 12px;
        background-color: rgba(0, 0, 0, .5);
        color: white;
        padding: 5px 10px;
        border-radius: 20px;
        opacity: 0;
        transition: top 0.5s .5s, opacity .5s;
      }

      &.copy-success::before {
        top: 30px;
        opacity: 1;
        transition: top .5s, opacity .5s;
      }
    }

    #product-status {
      font-size: 14px;
    }

    #product-promote {
      padding: 10px;
      border-radius: 5px;
      border: 1px solid #dfe0e1;
      margin-top: 20px;
    }
  }

  .breadcrumb {
    border: 0;
    background-color: transparent;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    background-color: #f5f5f5;
    padding: 25px 20px;
    display: flex;
    justify-content: flex-start;
    width: 100%;
    margin: 0 0 60px 0;

    >li.breadcrumb-item {
      padding: 0 10px 0 0;
      white-space: inherit;
      word-break: break-word;
      font-size: 14px;
      text-shadow: 0 1px 0 #FFF;

      a {
        color: inherit;
        text-decoration: none;
        ;
      }
    }
  }

  .pagination {
    display: flex;
    justify-content: center;
    gap: 10px;
    line-height: 24px;
    ;
  }

  #danh-muc-page {
    aside {
      border: 1px solid #f5f5f5;
      padding: 10px;
      text-align: left;
      margin-bottom: 20px;

      a {
        color: inherit;
        text-decoration: none
      }

      ;

      ul {
        list-style: none;
        padding: 10px 0 0 0;
        display: flex;
        flex-wrap: wrap;

        li {
          a {
            padding: 5px 10px;
            font-size: 14px;
            line-height: 24px;
          }

          &:hover {
            a {
              color: #ad052d;
            }
          }
        }

      }

      h2.sidebar-title {
        font-size: 16px;
        font-weight: bold;
        margin-bottom: 10px;
        padding: 8px 16px;
        background-color: #eeefef;

      }
    }
  }
</style>